import { useQuery } from '@tanstack/react-query';
import { whoami, type Whoami } from '@/services/api/endpoints';

export function useWhoami() {
  return useQuery<Whoami>({
    queryKey: ['whoami'],
    queryFn: whoami,
    staleTime: 5 * 60 * 1000,
    // whoami is the auth signal the landing/AuthGate keys off. NAA token
    // acquisition can fail transiently on the first brokered attempt, so retry
    // a couple of times before showing the "not authenticated" landing.
    retry: 2,
  });
}
